export const ROI_FIELDS = [
  ['branches', 'Branches', 1, 500, 1],
  ['txns_day', 'Transactions / day / branch', 0, 1000000, 1],
  ['basket', 'Average basket (GHS)', 0, 1000000000, 'any'],
  ['expiry_month', 'Total expiry write-off / month (GHS)', 0, 1000000000, 'any'],
  ['shrinkage_pct', 'Shrinkage (% of turnover)', 0, 100, 'any'],
  ['hours_month', 'Total admin hours / month', 0, 1000000, 'any'],
  ['hourly', 'Staff cost / hour (GHS)', 0, 1000000, 'any'],
  ['plan_month', 'Assumed software cost / month (GHS)', 0, 1000000000, 'any'],
];
export const RATE_FIELDS = [
  ['expiry_cut', 'Expiry avoided (%)'], ['shrinkage_cut', 'Shrinkage recovered (%)'],
  ['time_cut', 'Admin time saved (%)'], ['repeat_uplift', 'Turnover uplift (%)'],
  ['margin', 'Gross margin on uplift (%)'],
];
export const INITIAL_VALUES = { branches: 1, txns_day: 90, basket: 55, expiry_month: 1200, shrinkage_pct: 1.5, hours_month: 18, hourly: 18, plan_month: 350 };
export const INITIAL_RATES = { expiry_cut: 60, shrinkage_cut: 40, time_cut: 70, repeat_uplift: 2, margin: 22 };
export const ghs = (number) => `GHS ${Math.round(number).toLocaleString('en-GH')}`;

export const estimateRoi = (values, percentages) => {
  const fields = [...ROI_FIELDS, ...RATE_FIELDS.map(([key, label]) => [key, label, 0, 100, 'any'])];
  const all = { ...values, ...percentages };
  if (fields.some(([key, , min, max, step]) => all[key] === '' || !Number.isFinite(Number(all[key])) || Number(all[key]) < min || Number(all[key]) > max || (step === 1 && !Number.isInteger(Number(all[key]))))) return null;
  const v = Object.fromEntries(Object.entries(values).map(([key, value]) => [key, Number(value)]));
  const rates = Object.fromEntries(Object.entries(percentages).map(([key, value]) => [key, Number(value) / 100]));
  const turnover = v.txns_day * v.basket * 26 * v.branches;
  const expiry = v.expiry_month * rates.expiry_cut;
  const shrink = turnover * v.shrinkage_pct / 100 * rates.shrinkage_cut;
  const time = v.hours_month * v.hourly * rates.time_cut;
  const repeat = turnover * rates.repeat_uplift * rates.margin;
  const recovery = expiry + shrink + time + repeat;
  return { turnover, expiry, shrink, time, repeat, recovery, plan: v.plan_month, net: recovery - v.plan_month };
};